import { Box, Flex, Image, Spinner, Text } from '@chakra-ui/react'
import type { WaitingDiscountRequestVehicle } from 'BrokerTsLib/src/dtos'
import { formatPersonFullName } from 'BrokerTsLib/src/dtos'
import { formatDate } from 'BrokerTsLib/src/Utils/formatPrice'
import { Link, useNavigate } from 'react-router'

import { CompanyLogo } from '@/components/CompanyLogo'
import { TableData, TableRow } from '@/components/Grid'
import { StepsProgress } from '@/components/StepsProgress'
import { logoSize } from '@/containers/concepts/ConceptRow'
import { useGetBrandLogo } from '@/hooks/useDocuments'
import car from '@/images/apps/car.svg'

export const OverLimitDiscountRequestRow = ({ item }: { item: WaitingDiscountRequestVehicle }) => {

  const navigate = useNavigate()
  const { data: dataLogo, isLoading: isLoadingLogo, isError: isErrorLogo } = useGetBrandLogo(item?.vehicle?.druh, item?.vehicle?.znacka)
  const navigateTarget = `/steps/2/${item.paramsId}?offer=${item.offerId}`

  let discountInfo = ''
  item.discounts.forEach(d => {
    if (discountInfo.length > 0) {
      discountInfo = discountInfo + ', '
    }
    discountInfo = discountInfo + `${d.requestedValue}% ${d.name}`
  })

  const brokerFullName = `${item.requestedByFirstName ?? ''} ${item.requestedByFirstName ?? ''}`.trim()
  const subject = `${item?.vehicle?.znacka ?? ''} ${item?.vehicle?.model ?? ''}`.trim()
  const insureeName = formatPersonFullName(item.policyHolder)

  return (
    <TableRow cursor='pointer'
      onClick={(e) => {
        navigate(navigateTarget)
      }}
    >
      <TableData>
        <Flex sx={{ columnGap: 4, rowGap: 1, flexWrap: 'wrap' }}>
          <Box sx={{ display: 'grid', gap: 1 }} className="contract__id-progress">
            <Link to={navigateTarget} >
              {/* <Text sx={{ color: 'primary.400', fontSize: 'xl', fontWeight: 'semibold' }}>{id}</Text> */}
              <Text sx={{ fontWeight: 'bold' }}>{item.paramsId} / #{item.offerId}</Text>

              <StepsProgress progress={(item.step ?? 1)}
                // maxSteps={item.type == 2 ? 4 : 5}
              />
            </Link>
          </Box>
        </Flex>
      </TableData>

      <TableData>
        {item.dateCreated && <Text sx={{ fontSize: 'sm' }}>
          {formatDate(item.dateCreated, 'd.M.yyyy')}
        </Text>
        }

        {item.insuranceStartDate && (
          <Text sx={{ fontSize: 'sm', fontWeight: 'semibold' }}>
            {formatDate(item.insuranceStartDate, 'd.M.yyyy')}
          </Text>
        )}
      </TableData>

      <TableData verticalAlign='middle' sx={{ px: 0 }}>
        {isLoadingLogo && <Spinner />}
        {!isLoadingLogo && isErrorLogo && <Image src={car} />}
        {!isLoadingLogo && !isErrorLogo && dataLogo?.data &&
                    <Image
                      src={'data:image/png;base64,' + dataLogo?.data}
                      alt={item?.vehicle?.znacka ?? undefined}
                      sx={{
                        width: {
                          base: 12,
                          md: `${logoSize}px`,
                        },
                        height: {
                          base: 12,
                          md: `${logoSize}px`,
                        },
                        transition: 'all 200ms ease-in-out',
                      }}
                    />
        }
        {/* <Avatar size="sm" colorScheme="primary" name={insureeName.trim()} /> */}
      </TableData>

      <TableData sx={{ pl: 0 }}>
        {insureeName && <Text sx={{ fontSize: 'sm' }}>{insureeName}</Text>}


        {!!subject &&
                    <Text
                      sx={{
                        fontWeight: 'bold',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {subject}
                    </Text>
        }
      </TableData>

      <TableData>
        <CompanyLogo
          insurer={{ id: item.insurerId, name: item.insurerName }}
          offerType={item.offerType}
          width="64px"
          maxH="48px"
        />
      </TableData>

      <TableData>
        <Text sx={{ fontWeight: 'bold' }}>
          {discountInfo}
        </Text>

        <Flex columnGap={1}>
          <Text sx={{ fontSize: 'sm', fontWeight: 'semibold' }}>
            {formatDate(item.requested, 'd.M.yyyy')}
          </Text>

          <Text>/</Text>

          {brokerFullName && (
            <Text sx={{ color: 'primary.500', fontSize: 'sm', fontWeight: 'semibold' }}>
              {brokerFullName}
            </Text>
          )}
        </Flex>
      </TableData>
    </TableRow>
  )
}